import AppHeader from "@/components/AppHeader";

export default {
  name: "master-approval-detail",
  components: {
    AppHeader
  },
  created() {
    this.getCompany();
    this.getDepartment();
    this.getApproval();
  },
  data() {
    return {
      companyName: "",
      departmentName: "",
      approvals: [],
      getCompanyEnd: false,
      getDepartmentEnd: false,
      getApprovalEnd: false
    };
  },
  computed: {
    attendanceType() {
      return this.$t(`attendanceTypes.${this.$route.params.approval_type}`);
    }
  },
  methods: {
    async getCompany() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_COMPANY", {
          id: this.$route.params.company_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.companyName = res.company.name;
      this.getCompanyEnd = true;
    },
    async getDepartment() {
      let data = {};
      let res = await this.$store
        .dispatch("SHOW_DEPARTMENT", {
          id: this.$route.params.department_id,
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.departmentName = res.department.name;
      this.getDepartmentEnd = true;
    },
    async getApproval() {
      let data = {
        company_id: this.$route.params.company_id,
        department_id: this.$route.params.department_id,
        approval_type: this.$route.params.approval_type
      };
      let res = await this.$store
        .dispatch("GET_APPROVAL_BY_DEPARTMENT_TYPE", {
          data: data
        })
        .catch(err => {
          console.log(err);
          return;
        });
      this.approvals = res.approvals;
      this.getApprovalEnd = true;
    },
    goApprovalEdit() {
      if (this.approvals.length > 0) {
        this.$router.push({
          path: `/master_approval/${this.$route.params.company_id}/${this.$route.params.department_id}/${this.$route.params.approval_type}/${this.approvals[0].approval_id}`
        });
      } else {
        this.$router.push({
          path: `/master_approval/${this.$route.params.company_id}/${this.$route.params.department_id}/${this.$route.params.approval_type}/0`
        });
      }
    }
  }
};
